(() => {
  const FORM_ID = "130664";
  const TEXTAREA_ID = `${FORM_ID}-textarea`;
  const MAX_WAIT_MS = 5000;
  const INTERVAL_MS = 100;

  const FIELD_MAP = {
    lastName:  `${FORM_ID}-text`,
    firstName: `${FORM_ID}-text-1`,
    company:   `${FORM_ID}-text-2`,
    email:     `${FORM_ID}-email-1`,
    phone:     `${FORM_ID}-phone-1`,
    address:   `${FORM_ID}-text-3`,
  };

  const buildTemplate = (id, title) => {
    return `■ お問合せ商品情報
ID: ${id}
商品名: ${title}

■ 以下にお問合せ内容をご記載ください

`;
  };

  const getParams = () => {
    const params = new URLSearchParams(window.location.search);
    const productId = params.get("product_id") || "";
    const productTitle = params.get("product_title") || "";
    return { productId, productTitle };
  };

  const setFieldValue = (id, value) => {
    const el = document.getElementById(id);
    if (!el || !value) return false;
    if (el.value && el.value.trim().length > 0) return true;
    el.value = value;
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  };

  let customerFieldsFilled = false;

  const fillCustomerFields = () => {
    if (customerFieldsFilled) return;
    const data = window.__contactCustomerData;
    if (!data) return;

    setFieldValue(FIELD_MAP.lastName, data.lastName);
    setFieldValue(FIELD_MAP.firstName, data.firstName);
    setFieldValue(FIELD_MAP.company, data.company);
    setFieldValue(FIELD_MAP.email, data.email);
    setFieldValue(FIELD_MAP.phone, data.phone);
    setFieldValue(FIELD_MAP.address, data.address);

    customerFieldsFilled = true;
  };

  const setTextareaIfPossible = () => {
    const { productId, productTitle } = getParams();
    const textarea = document.getElementById(TEXTAREA_ID);

    if (!textarea) return { ok: false, reason: "form_not_ready" };

    // 顧客情報を自動挿入
    fillCustomerFields();

    if (!productId || !productTitle) return { ok: true, reason: "no_product_params" };

    // 既にユーザーが入力していたら上書きしない
    if (textarea.value && textarea.value.trim().length > 0) {
      return { ok: true, reason: "already_has_value" };
    }

    textarea.value = buildTemplate(productId, productTitle);
    textarea.dispatchEvent(new Event("input", { bubbles: true }));
    textarea.dispatchEvent(new Event("change", { bubbles: true }));

    return { ok: true, reason: "set" };
  };

  const runWithWait = () => {
    const start = Date.now();

    const tick = () => {
      const result = setTextareaIfPossible();

      if (result.ok) return;

      if (result.reason === "form_not_ready") {
        if (Date.now() - start >= MAX_WAIT_MS) {
          console.warn(`[c_contact] form not found within ${MAX_WAIT_MS}ms`);
          return;
        }
        setTimeout(tick, INTERVAL_MS);
        return;
      }
    };

    tick();
  };

  // 通常ロード
  document.addEventListener("DOMContentLoaded", runWithWait);

  // bfcache/戻るなどでも発火させる
  window.addEventListener("pageshow", runWithWait);
})();
